import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface Credentials {
  about: string;
  address: string;
  accessToken: string;
  city_id: string;
  company_name?: string;
  created_at: string;
  deleted_at: string;
  email: string;
  firstname: string;
  city: string;
  state: string;
  country: string;
  id: number;
  image: string;
  is_active: true;
  is_completed: false;
  is_verified: true;
  lastname: string;
  phoneno: string;
  state_id: string;
  userbilling?: any;
  userRole: string;
  usershipping?: any;
  vendor_no: string;
  email_notification: number;
  
  zip_code: string;
  billing_address: string;
  billing_state: string;
  billing_city: string;
  billing_postal_code: string;
  shipping_state: string;
  shipping_city: string;
  shipping_address: string;
  shipping_postal_code: string;
  billing_country: string;
  shipping_country: string;
  
}

const credentialsKey = 'credentials';

/**
 * Provides storage for authentication credentials.
 * The Credentials interface should be replaced with proper implementation.
 */
@Injectable({
  providedIn: 'root'
})
export class CredentialsService {
  private _credentials: Credentials | null = null;

  constructor() {
    const savedCredentials =
      sessionStorage.getItem(credentialsKey) ||
      localStorage.getItem(credentialsKey);
    if (savedCredentials) {
      this._credentials = JSON.parse(savedCredentials);
    }
  }

  /**
   * Checks is the user is authenticated.
   * @return True if the user is authenticated.
   */
  isAuthenticated(): boolean {
    return !!this.credentials;
  }

  /**
   * Gets the user credentials.
   * @return The user credentials or null if the user is not authenticated.
   */
  get credentials(): Credentials | null {
    return this._credentials;
  }

  /**
   * Sets the user credentials.
   * The credentials may be persisted across sessions by setting the `remember` parameter to true.
   * Otherwise, the credentials are only persisted for the current session.
   * @param credentials The user credentials.
   * @param remember True to remember credentials across sessions.
   */
  setCredentials(credentials?: Credentials, remember?: boolean) {
    this._credentials = credentials || null;

    if (credentials) {
      const storage = remember ? localStorage : sessionStorage;
      storage.setItem(credentialsKey, JSON.stringify(credentials));
    } else {
      sessionStorage.removeItem(credentialsKey);
      localStorage.removeItem(credentialsKey);
    }
  }
}
